import {translations} from 'presentation/translations-new';

const {bookHealth, bookExams, bookOdonto, bookTelehealth, emergencyTelehealth, healthGuideAll} =
	translations['pt-br'].privateFlow.services;
const {
	title: profile,
	locationSelection: {city, state},
	changePassword,
} = translations['pt-br'].privateFlow.profile;
const {changePlan} = translations['pt-br'].privateFlow.accountRegister;
const {title} = translations['pt-br'].privateFlow.requestAuthorizations.initialFlow;

export const PATH_TITLE: Record<string, string> = {
	'agendar-teleconsulta': bookTelehealth,
	'pronto-atendimento-digital': emergencyTelehealth,
	'agendar-consulta': bookHealth,
	'agendar-dentista': bookOdonto,
	'agendar-exame': bookExams,
	'meu-perfil/estado': state.pageTitle,
	'meu-perfil/cidade': city.pageTitle,
	'meu-perfil/plano': changePlan,
	'meu-perfil/alterar-senha': changePassword.title,
	'meu-perfil': profile,
	autorizacoes: title,
	'rede-de-atendimento': healthGuideAll,
};
